import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fulfilToken: null,
  giftCards: { data: [] },
  giftCardsLoading: false,
  giftCardsError: null,
  giftCardsFetched: false,
  products: { data: [] },
  productsLoading: false,
  productsError: null,
  productsFetched: false,
  giftCardDetail: null,
  giftCardDetailLoading: false,
  giftCardDetailError: null,
  productDetail: null,
  productDetailLoading: false,
  productDetailError: null,
  orderHistory: [],
  orderHistoryLoading: false,
  orderHistoryError: null,
};

const giftcardSlice = createSlice({
  name: "giftcard",
  initialState,
  reducers: {
    setFulfilToken: (state, action) => ({
      ...state,
      fulfilToken: action.payload,
    }),
    setGiftCards: (state, action) => ({
      ...state,
      giftCards: action.payload,
    }),
    setGiftCardsLoading: (state, action) => ({
      ...state,
      giftCardsLoading: action.payload,
    }),
    setGiftCardsError: (state, action) => ({
      ...state,
      giftCardsError: action.payload,
    }),
    setGiftCardsFetched: (state, action) => ({
      ...state,
      giftCardsFetched: action.payload,
    }),
    setProducts: (state, action) => ({
      ...state,
      products: action.payload,
    }),
    setProductsLoading: (state, action) => ({
      ...state,
      productsLoading: action.payload,
    }),
    setProductsError: (state, action) => ({
      ...state,
      productsError: action.payload,
    }),
    setProductsFetched: (state, action) => ({
      ...state,
      productsFetched: action.payload,
    }),
    setGiftCardDetail: (state, action) => ({
      ...state,
      giftCardDetail: action.payload,
    }),
    setGiftCardDetailLoading: (state, action) => ({
      ...state,
      giftCardDetailLoading: action.payload,
    }),
    setGiftCardDetailError: (state, action) => ({
      ...state,
      giftCardDetailError: action.payload,
    }),
    clearGiftCardDetail: (state) => ({
      ...state,
      giftCardDetail: null,
      giftCardDetailLoading: false,
      giftCardDetailError: null,
    }),
    setProductDetail: (state, action) => ({
      ...state,
      productDetail: action.payload,
    }),
    setProductDetailLoading: (state, action) => ({
      ...state,
      productDetailLoading: action.payload,
    }),
    setProductDetailError: (state, action) => ({
      ...state,
      productDetailError: action.payload,
    }),
    clearProductDetail: (state) => ({
      ...state,
      productDetail: null,
      productDetailLoading: false,
      productDetailError: null,
    }),
    setOrderHistory: (state, action) => ({
      ...state,
      orderHistory: action.payload,
    }),
    setOrderHistoryLoading: (state, action) => ({
      ...state,
      orderHistoryLoading: action.payload,
    }),
    setOrderHistoryError: (state, action) => ({
      ...state,
      orderHistoryError: action.payload,
    }),
  },
});

export const {
  setFulfilToken,
  setGiftCards,
  setGiftCardsLoading,
  setGiftCardsError,
  setGiftCardsFetched,
  setProducts,
  setProductsLoading,
  setProductsError,
  setProductsFetched,
  setGiftCardDetail,
  setGiftCardDetailLoading,
  setGiftCardDetailError,
  clearGiftCardDetail,
  setProductDetail,
  setProductDetailLoading,
  setProductDetailError,
  clearProductDetail,
  setOrderHistory,
  setOrderHistoryLoading,
  setOrderHistoryError,
} = giftcardSlice.actions;
export default giftcardSlice;
